import React, { forwardRef, useState } from "react";
import { FaRetweet } from "react-icons/fa";
import { Button, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";


const HidePrivateInfoButton = ({isHidden, onHidePrivate, isBtnDisabled}) => {

  const hideInfoDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Hide private informations</p>
  );

  const showInfoDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Show private informations</p>
  );


  return (
    <div>
      <Tooltip
        title={isHidden ? showInfoDescription : hideInfoDescription}
        disableinteractive="true"
        slotprops={{
          tooltip: {
            sx: {
              bgcolor: "#545859",
            },
          },
        }}
      >
        <Button
          variant="contained"
          className="context-menu-btns"
          disabled={isBtnDisabled} 
          sx={{
            backgroundColor: "#ffffff",
            border: "1px solid #00449e",
            borderColor: "#00449e",
            cursor: "pointer",
            borderRadius: "0.5rem",
            color: "#00449e",
                "&:hover": {
                  backgroundColor: "#eaf1fb",
                },
                "&:focus:not(:hover)": {
                  backgroundColor: "#ffffff",
                  boxShadow: "none",
                },
          }}
          onClick={onHidePrivate}
        >
          {isHidden === true ? (<VisibilityOff size="1rem" color="#00449e" />) : (<Visibility size="1rem" color="#00449e" />)}
        </Button>
      </Tooltip>
    </div>
  );
};

export default HidePrivateInfoButton;
